/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalVerificationInfoDto } from '../../models/external-verification-info-dto';

export interface GetExternalVerificationInfo$Params {
  token: string;
  'X-API-Version'?: string;
}

export function getExternalVerificationInfo(http: HttpClient, rootUrl: string, params: GetExternalVerificationInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalVerificationInfoDto>> {
  const rb = new RequestBuilder(rootUrl, getExternalVerificationInfo.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalVerificationInfoDto>;
    })
  );
}

getExternalVerificationInfo.PATH = '/api/user-profile/external-verification-info';
